import {useParams } from "react-router";
import "./index.css"
import industryData from "../../Database/industry_experience.json";
import parse from "html-react-parser";
import MetaTags from "../../../components/MetaTags";
export default function IndustryExperiences() {
    const ExpDataArray = industryData.IndustryExpData
    const { eid } = useParams();
    const experience = ExpDataArray.find((exp) => exp._id === eid)
    let text_experience:string;
    text_experience = experience?._job_value_provided ?? '';
    const moment = require('moment');
    function limitText(text:string, maxLength:number) {
        if (text.length > maxLength) {
          return text.substring(0, maxLength);
        }
        return text;
      }
    let text_experience_seo:string;
    text_experience_seo = experience?._small_description_seo ?? '';
    let small_description_seo = limitText(text_experience_seo, 170);
    return(
        <>
      <MetaTags 
        title={experience?._job_title}
        description={small_description_seo}
        image={experience?._principal_img} />
        <div id="wd-experience-post" className="pt-0 pb-5 me-4">
        <div className="row">
            <div className="col-md-1 col-lg-1"></div>
            <div className="col-md-10 col-lg-10">
                <h2 className="wd-experience-title"> {experience?._job_title} </h2> <hr/>
                <div id="wd-authored-row" className="row">
                    <div className="col-12 col-md-3">
                        <div className="" id="wd-author-by">COMPANY</div>
                        <div className="" id="wd-author">{experience?._business}</div>
                    </div>
                    <div className="col-12 col-md-3">
                        <div className="" id="wd-author-by">LOCATION</div>
                        <div className="" id="wd-author">{experience?._location}</div>
                    </div>
                    <div className="col-12 col-md-3">
                        <div className="" id="wd-author-by">DATE FROM</div>
                         <div className="" > {moment(experience?._date_from).format('MM/YYYY')}</div>
                    </div>
                    <div className="col-12 col-md-3">
                        <div className="" id="wd-author-by">DATE TO</div>
                         <div className="" > {experience?._date_to ? moment(experience._date_to).format('MM/YYYY') : 'Present'}</div>
                    </div>
                </div>
                <div id="wd-post-content" className="pt-4 pb-4">
                <div id="wd-post-image" className="pb-4 d-flex justify-content-center">
                    <img src={experience?._principal_img} className="wd-image-home" />
                </div>
                <div id="wd-post-text pt-3" className="text-start" >
                {parse(text_experience)}
                </div>
                </div>
            </div>
            <div className="col-md-1 col-lg-1"></div>
        </div>
    </div>
    </>
    );
}